import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="tooltip"
export default class TooltipController extends Controller {
  connect() {
    // Don't enable tooltips on mobile devices
    if (!globalThis.AppConfig.isDesktop) return

    document.addEventListener('click', this.closeTooltip)

    $('.tooltip').remove()

    this.tooltip = new bootstrap.Tooltip(this.element, {
      boundary: document.body,
      sanitize: false
    })
  }

  disconnect() {
    if (!globalThis.AppConfig.isDesktop) return

    document.removeEventListener('click', this.closeTooltip)

    const tooltip = this.tooltip
    this.tooltip = null

    if (!tooltip) return

    const dispose = () => {
      if (
        globalThis.bootstrap?.Tooltip.getInstance(this.element) === tooltip
      ) {
        tooltip.dispose()
      }
    }

    // Bootstrap's hide callback reads _activeTrigger. Disposing during the
    // transition nulls that object and causes `_isWithActiveTrigger` to throw.
    if (this.element.hasAttribute('aria-describedby')) {
      this.element.addEventListener('hidden.bs.tooltip', dispose, {
        once: true
      })
      tooltip.hide()
      setTimeout(dispose, 1000)
    } else {
      dispose()
    }
  }

  closeTooltip = () => {
    this.tooltip?.hide()
  }
}
